import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer">
        <div className="footer-left">
          <h2>FLYINGO</h2>
        </div>
        <div className="footer-right">
          <p>Your ultimate flight booking experience.</p>
        </div>
      </footer>
    );
};

export default Footer;
